import { VerificationSearch } from '@/models';
import { VerificationsViewModel } from '@/viewModels/verifications';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class Verifications extends Vue {
  public viewModel = new VerificationsViewModel();
  public command = new VerificationSearch();
  public volunteerId = null;
  public pagination: any = {};
  public get instances() {
    return this.$dataService.instanceNames();
  }
  public get status() {
    return this.$dataService.status();
  }
  public get busy() {
    return this.$store.getters.isBusy;
  }
  @Watch('pagination') onPageChanged(o, n) {
    this.search();
  }
  public get report() {
    return this.$store.getters.verifications;
  }
  public search() {
    if (!this.command.instanceKey) {
      return;
    }
    if (this.volunteerId) {
      this.command.volunteerIds = [this.volunteerId];
    }
    const { sortBy, descending, page, rowsPerPage } = this.pagination;
    if (page) {
      this.command.pageNumber = page > 0 ? page - 1 : page;
    }
    if (rowsPerPage) {
      this.command.pageSize = rowsPerPage;
    }
    this.$api.loadVolunteerVerifications(this.command);
  }
  mounted() {
    this.command.status = 'x:ready';

    this.search();
  }
}
